module.exports = __webpack_public_path__ + "img/Tablet - 70.2035da09.png";